<script>
import { generateConfirm, confirmTypeProps } from '@utils/feeline-confirm'
export default {
  props: {
    size: {
      type: String,
      default: 'sm',
      require: false,
    },
    backdropClose: {
      type: Boolean,
      require: false,
    },
    hideActionButton: {
      type: Boolean,
      require: false,
    },
    ...confirmTypeProps,
  },
  computed: {
    confirmComputed() {
      return generateConfirm(this.type)
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit')
    },
  },
}
</script>

<template>
  <div>
    <CModal
      id="base-modal-confirm"
      :title="confirmComputed.title"
      v-bind="$attrs"
      :size="size"
      centered
      :close-on-backdrop="backdropClose"
      v-on="$listeners"
    >
      <slot>{{ confirmComputed.msg }}</slot>
      <template v-slot:footer>
        <div class="d-flex flex-column w-100 justify-content-center">
          <slot name="action" :submit="handleSubmit">
            <CButton
              v-if="confirmComputed.btn && !hideActionButton"
              color="danger"
              class="mb-2"
              @click="handleSubmit"
            >
              {{ confirmComputed.btn }}
            </CButton>
          </slot>
          <CButton color="light" @click="$emit('closeModal')">{{
            confirmComputed.close_btn || $t('common.cancel')
          }}</CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<style lang="scss" scoped>
#base-modal-confirm {
  ::v-deep .modal-header {
    padding-bottom: 0;
    border-bottom: none;
    .modal-title {
      font-size: 1.09375rem;
      font-weight: 700;
      line-height: 1.2;
      color: $custom-modal-text-color;
    }
  }

  @media (min-width: 576px) {
    ::v-deep .modal-sm {
      min-width: 340px;
    }
  }

  ::v-deep .modal-body {
    font-weight: 700;
    color: $custom-modal-text-color;
    white-space: pre-line;
  }

  ::v-deep .modal-footer {
    border-top: none;
    .btn {
      width: 150px;
      margin: auto;
    }
  }

  ::v-deep .close {
    display: none;
  }
}
</style>
